import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

type FormSectionProps = React.HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

/**
 * @summary Group a sequence of Form Inputs in a 2 column grid.
 **/
export function FormSection({
  children,
  className,
  ...props
}: FormSectionProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6",
        "@md/form:grid-cols-2 @md/form:gap-6",
        "[&>*]:min-w-0",
        "[&>.col-span-2]:col-span-1",
        "md:[&>.col-span-2]:col-span-2",
        "@md/form:[&>.col-span-2]:col-span-2",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
